import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle--down",
  "use": "icon-triangle--down-usage",
  "viewBox": "0 0 9 6",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 6\" id=\"icon-triangle--down\"><path d=\"M4.5 6 .603.75h7.794L4.5 6Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol